import { render } from "./ViewModeleNotification.vue?vue&type=template&id=0afa2a81&ts=true"
import script from "./ViewModeleNotification.vue?vue&type=script&lang=ts"
export * from "./ViewModeleNotification.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__